import * as React from 'react'
import * as PropTypes from 'prop-types'
import styled, { css } from 'styled-components'

const Title = styled.h5`
  font-size: 0.75rem;
  font-color: var(--color-fg);
  font-weight: var(--font-weight-bold);
  line-height: 1.3125rem;
  text-align: center;
  margin: 0;
`

const Card = styled.label`
  border-radius: 5px;
  box-sizing: border-box;
  height: 2.8125rem;
  padding: 0.75rem 1.5625rem;
  display: block;
  user-select: none;
  background-color: transparent;
  border: 1px solid var(--color-fg-lighter);

  ${props =>
    props.checked &&
    css`
      background-color: #f17b3d;
      border-color: #f17b3d;

      ${Title} {
        color: #ffffff;
        font-weight: var(--font-weight-boldest);
      }
    `};
`

const HiddenCheckbox = styled.input.attrs({ type: 'checkbox' })`
  border: 0;
  clip: rect(0 0 0 0);
  clippath: inset(50%);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  white-space: nowrap;
  width: 1px;
`

function PreferenceItem(props) {
  const {
    itemData,
    className,
    onChange,
    enableSelect,
    selected,
    ...restProps
  } = props

  const [checked, setCheck] = React.useState(selected || false)

  const { name } = itemData

  const updateCheck = e => {
    if (!enableSelect) {
      e.target.checked = false
    }
    setCheck(e.target.checked)
  }

  return (
    <Card className={className} checked={checked}>
      <Title>{name}</Title>
      <HiddenCheckbox
        checked={selected}
        onChange={e => {
          updateCheck(e)
          return onChange(e)
        }}
        {...restProps}
      />
    </Card>
  )
}

PreferenceItem.defaultProps = {
  className: '',
  enableSelect: true,
  onChange: () => {},
}

PreferenceItem.propTypes = {
  className: PropTypes.string,
  enableSelect: PropTypes.bool,
  itemData: PropTypes.shape({
    name: PropTypes.string.isRequired,
  }).isRequired,
  onChange: PropTypes.func,
}

export default PreferenceItem
